import { AbstractPmsApiService } from "./abstract.service";
import { MabeetProfile } from "../models";

/**
 * @class MabeetProfileService
 * @abstract
 * @extends {AbstractPmsApiService<MabeetProfile>}
 */
export class MabeetProfileService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/profile';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {MabeetProfile}
     * @protected
     */
    newModel(attributes, ...params) {

        return new MabeetProfile(attributes);
    }

    /**
     * @returns {Promise.<MabeetProfile>}
     */
    get() {
        return this.http
            .get(this.url(), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {MabeetProfile} MabeetProfile
     * @returns {Promise.<MabeetProfile>}
     */
    save(MabeetProfile) {
        return this.http
            .post(this.url(), MabeetProfile, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/mabeet-profile.service.js